import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';
import { ShieldCheck, Clock, RefreshCcw } from 'lucide-react';

const trustItems = [
    { icon: ShieldCheck, text: "No sales pressure. We tell you honestly if we're a fit." },
    { icon: Clock, text: 'No long-term trap. 3-month minimum, then month-to-month.' },
    { icon: RefreshCcw, text: 'No restart fees. Free replacement guarantee built in.' },
];

export function TrustCallouts() {
    return (
        <>
            <section className="bg-white py-16" data-testid="direct-contact">
                <div className="max-w-2xl mx-auto px-6 lg:px-12 text-center">
                    <motion.div {...fadeUp}>
                        <p className="text-[#6B7280] text-lg mb-2">Prefer to reach out directly?</p>
                        <a href="mailto:adam@whiteglovehiring.com" className="text-navy-900 font-bold text-lg hover:text-gold-400 transition-colors" data-testid="contact-email">
                            adam@whiteglovehiring.com
                        </a>
                        <p className="text-[#6B7280] text-sm mt-2">Response time: within one business day</p>
                    </motion.div>
                </div>
            </section>

            <section className="bg-[#F8F9FA] py-16" data-testid="trust-callouts">
                <div className="max-w-5xl mx-auto px-6 lg:px-12">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {trustItems.map((item, i) => (
                            <motion.div
                                key={item.text}
                                {...staggeredFadeIn(i * 0.1)}
                                className="flex items-start gap-3 bg-white border border-gray-100 rounded-sm p-6 shadow-sm"
                                data-testid={`trust-item-${i}`}
                            >
                                <item.icon size={20} className="text-gold-400 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                                <p className="text-[#6B7280] text-sm leading-relaxed">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
